import { t } from "@lingui/macro";
import graphql from "babel-plugin-relay/macro";
import React from "react";
import { Pressable } from "react-native";
import { useFragment } from "react-relay";

import { convertCardBrandToIcon } from "@whoosh/design-system/src/components/icons_v2/creditCards";
import {
  Box,
  HStack,
  Text,
  VStack,
} from "@whoosh/design-system/src/components/primitive";

import { SquareCardFragment$key } from "./__generated__/SquareCardFragment.graphql";
import { normalizeCardBrand } from "./utils/normalizeCardBrand";

type SquareCardProps = {
  fragmentRef: SquareCardFragment$key | null;
  onPress: (id: string) => void;
  rightIcon?: React.ReactNode;
};

export const SquareCard = ({
  fragmentRef,
  onPress,
  rightIcon,
}: SquareCardProps) => {
  const card = useFragment(SquareCardFragmentString, fragmentRef);
  const cardBrand = normalizeCardBrand(card?.cardBrand || "");
  return (
    <Pressable
      onPress={() => card?.id && onPress(card?.id)}
      testID="square-card"
    >
      <HStack py={2} justifyContent="space-between" alignItems="center" gap={2}>
        <Box
          bg="surface-secondary"
          width={40}
          height={26}
          borderRadius="2"
          justifyContent="center"
          alignItems="center"
        >
          {convertCardBrandToIcon(card?.cardBrand)}
        </Box>
        <VStack flexGrow={1}>
          <HStack gap={1}>
            <Text variant="mainBaseSemiBold">{t`${cardBrand} ending ${
              card?.lastFour ?? ""
            }`}</Text>
            {card?.default ? (
              <Text
                variant="mainBaseSemiBold"
                color="text-secondary"
              >{t`Default`}</Text>
            ) : null}
          </HStack>

          <Text variant="mainTiny" color="text-secondary">
            {card?.expMonth}/{card?.expYear}
          </Text>
        </VStack>
        {rightIcon ? rightIcon : null}
      </HStack>
    </Pressable>
  );
};

const SquareCardFragmentString = graphql`
  fragment SquareCardFragment on SquareCardOnFile {
    __typename
    id
    cardBrand
    enabled
    expMonth
    expYear
    lastFour
    default
  }
`;
